import { render, staticRenderFns } from "./access-features-of-package-popup.html?vue&type=template&id=6e28c3be&scoped=true&external"
import script from "./access-features-of-package-popup.js?vue&type=script&lang=js&external"
export * from "./access-features-of-package-popup.js?vue&type=script&lang=js&external"
import style0 from "./access-features-of-package-popup.scss?vue&type=style&index=0&id=6e28c3be&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28c3be",
  null
  
)

export default component.exports